module.exports = __webpack_public_path__ + "img/Analyze-amico.ae990f3e.svg";